let winScrollTop=0;

$.fn.is_on_screen = function(){
    const win = $(window);
    const viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    //viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    const bounds = this.offset();
    //bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.bottom < bounds.top || viewport.top > bounds.bottom));
};

function parallax() {
    $('.parallax').each(function(){
        if ($(this).is_on_screen()) {
            const firstTop = $(this).offset().top;
            const $overlay = $(this).find(".parallax__overlay");
            const moveTop = (firstTop-winScrollTop)*0.3 //speed;
            $overlay.css("transform","translateY("+-moveTop+"px)");
        }

    });
}

$(window).scroll(function(e){
    winScrollTop = $(this).scrollTop();
    parallax();
});
